import React from 'react';
import { AuthenticateWithRedirectCallback } from '@clerk/clerk-react';
import { useLocation } from "react-router-dom";
import SeoHead from "../components/SeoHead";
import { useI18n } from "../i18n/i18n";

export default function SsoCallback() {
  const location = useLocation();
  const { t, localizePath } = useI18n();
  return (
    <div className="pageContainer" style={{ paddingTop: 40 }}>
      <SeoHead
        title={t("sso.title")}
        description={t("sso.description")}
        canonicalPath={location.pathname || localizePath("/sign-in/sso-callback")}
        noIndex={true}
      />
      <h1 style={{ position: "absolute", left: "-9999px" }}>{t("sso.heading")}</h1>
      <p>
        {t("sso.message")}
      </p>
      <AuthenticateWithRedirectCallback redirectUrl={localizePath("/")} />
    </div>
  );
}
